import styled from 'styled-components';

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.lightGreen};
  text-decoration: none;
`;
